import { NgModule } from '@angular/core';
import { ExampleNg6LibComponent } from './example-ng6-lib.component';
import { DialogComponent } from './dialog/dialog.component';



@NgModule({
  declarations: [ExampleNg6LibComponent, DialogComponent],
  imports: [
  ],
  exports: [ExampleNg6LibComponent]
})
export class ExampleNg6LibModule { }
